import { currencyFormatPtBr } from "../../../../../services/currencyFormat.service";
import { Server, Image, PlanBillingType } from "../../../Cloud.model";

function isPriceFree(image: Image, billingType: Server['plan']['billingType']):boolean{
    return  (billingType === PlanBillingType.GRATUITA || ((image.application? (image.application.price)?image.application.price.unitPrice === 0:true:true) && ((image.operationalSystem.price)?image.operationalSystem.price.unitPrice === 0:true)))
}

function getBillingTypeLabelToPrice(billingType: Server['plan']['billingType']):string{
    return (billingType ===  PlanBillingType.MENSAL) ? `/Mês` : `/Hora`;
}

function getPriceLabel(image:Image):string{
    let price = getCalcPriceImage(image);
    if (price === 0) return "Gratuito"
    return currencyFormatPtBr(price);
}

function getChargeTypeLabelToPrice(chargeType: Image['operationalSystem']['price']['chargeType']| null):string{
    return (chargeType === 'VCPU') ? 'por vCPU' : '';
}

export function getCalcPriceImage(image:Image):number{
    const unitPriceSystem = image.operationalSystem.price ? image.operationalSystem.price.unitPrice : 0;
    const unitPriceApp = (image.application && image.application.price) ? image.application.price.unitPrice : 0;
    return unitPriceSystem + unitPriceApp;
}

export function getFullPriceLabel(image: Image, billingType: Server['plan']['billingType']): string {

    if(billingType){
        if (isPriceFree(image, billingType))
            return "Gratuito"
    }

    const chargeType = (image.operationalSystem.price)? image.operationalSystem.price.chargeType:null
    let labelChargeType = getChargeTypeLabelToPrice(chargeType);
    let vbllingTypeLabel = (billingType)?getBillingTypeLabelToPrice(billingType):'';
    let price = getPriceLabel(image);

    return `${price} ${labelChargeType}${vbllingTypeLabel}`

}